'use client';

import { FormProvider, useForm } from 'react-hook-form';

import type { WriteInquiryRequest } from '@/store/server/common/support/support.dto';

import QnaForm from './Form';
import Title from './Title';

export interface QnAFormData {
  category: WriteInquiryRequest['bbs_div'];
  subject: WriteInquiryRequest['subject'];
  contents: WriteInquiryRequest['contents'];
  pushSms: WriteInquiryRequest['push_sms'];
  pushEmail: WriteInquiryRequest['push_email'];
  bbsFile: WriteInquiryRequest['bbs_file'];
}

interface QnaWriteProps {
  // 쿼리(category)로 받은 문의유형 고정값. QuestionSection 의 문의유형 select 고정에 사용.
  initialCategory?: string;
}

const QnaWrite = ({ initialCategory }: QnaWriteProps) => {
  const methods = useForm<QnAFormData>({
    defaultValues: {
      pushSms: 'N',
      pushEmail: 'N',
    },
  });

  return (
    <section className="flex w-full flex-col px-5 pt-8 pb-page-bottom">
      <Title />

      <FormProvider {...methods}>
        <QnaForm initialCategory={initialCategory} />
      </FormProvider>
    </section>
  );
};

export default QnaWrite;
